import { PaymentCourtFeesModel } from "src/app/core/view-models/about-court-fees";

export const dataPaymentCourtFees: PaymentCourtFeesModel =  new  PaymentCourtFeesModel/* {
    caseId:0,
    accId:0,
    billId:0,
    refCode: '220208-WPDE',
    payUserName: 'นางศศิธร วรสิงห์',
    paymentRefCode1: '65000072',
    paymentRefCode2: '20101',
    courtName: 'ศาลปกครองกลาง',
    courtBankAccount: "ชำระค่าธรรมเนียมศาลปกครอง",
    courtBankAccountNo: 96987,
    bankAgency: "หน่วยงานราชการ",
    fees: 100,
    payDate: new Date("February 10, 2022 12:05:00"),
    payCompleteDate:new Date("February 15, 2022 12:05:00"),
    payComplete: true,
    email:'',
    payInNo : null!,
    genQrCode:'',
    amount: null!,
    payCode:''
} */

